import {
  HOME_SET_VIEW_ROLE,
  HOME_SET_WIDGET_PREFERENCES,
  HOME_UPDATE_WIDGET_PREFERENCE,
  HOME_FETCH_POSTS_REQUEST,
  HOME_FETCH_POSTS_SUCCESS,
  HOME_FETCH_POSTS_FAILURE,
} from '@core/constants/actions';
import { HomeViewRole } from '@app/constants/home';
import { HomeState, WidgetPreference } from '@core/types/state';

const initialState: HomeState = {
  viewRole: null,
  widgetPreferences: null,
  posts: [],
  postsLoading: false,
  postsHasMore: true,
  postsCursor: null,
};

type HomeSetViewRoleAction = {
  type: typeof HOME_SET_VIEW_ROLE;
  viewRole: HomeViewRole;
};

type HomeSetWidgetPreferencesAction = {
  type: typeof HOME_SET_WIDGET_PREFERENCES;
  preferences: WidgetPreference[];
};

type HomeUpdateWidgetPreferenceAction = {
  type: typeof HOME_UPDATE_WIDGET_PREFERENCE;
  widgetId: string;
  isHidden: boolean;
};

type HomeFetchPostsRequestAction = {
  type: typeof HOME_FETCH_POSTS_REQUEST;
};

type HomeFetchPostsSuccessAction = {
  type: typeof HOME_FETCH_POSTS_SUCCESS;
  posts: any[];
  cursor: string | null;
  hasMore: boolean;
};

type HomeFetchPostsFailureAction = {
  type: typeof HOME_FETCH_POSTS_FAILURE;
};

type HomeAction =
  | HomeSetViewRoleAction
  | HomeSetWidgetPreferencesAction
  | HomeUpdateWidgetPreferenceAction
  | HomeFetchPostsRequestAction
  | HomeFetchPostsSuccessAction
  | HomeFetchPostsFailureAction;

const home = (
  state: HomeState = initialState,
  action: HomeAction
): HomeState => {
  switch (action.type) {
    case HOME_SET_VIEW_ROLE:
      return {
        ...state,
        viewRole: action.viewRole,
      };
    case HOME_SET_WIDGET_PREFERENCES:
      return {
        ...state,
        widgetPreferences: action.preferences,
      };
    case HOME_UPDATE_WIDGET_PREFERENCE:
      if (!state.widgetPreferences) return state;
      return {
        ...state,
        widgetPreferences: state.widgetPreferences.map((pref) =>
          pref.widgetId === action.widgetId
            ? {
                ...pref,
                isHidden: action.isHidden,
              }
            : pref
        ),
      };
    case HOME_FETCH_POSTS_REQUEST:
      return {
        ...state,
        postsLoading: true,
      };
    case HOME_FETCH_POSTS_SUCCESS:
      return {
        ...state,
        postsLoading: false,
        posts: [...state.posts, ...action.posts],
        postsCursor: action.cursor,
        postsHasMore: action.hasMore,
      };
    case HOME_FETCH_POSTS_FAILURE:
      return {
        ...state,
        postsLoading: false,
      };
    default:
      return state;
  }
};

export default home;
